import { render, staticRenderFns } from "./UserRemoveChiefAction.vue?vue&type=template&id=ae707e96"
import script from "./UserRemoveChiefAction.vue?vue&type=script&lang=js"
export * from "./UserRemoveChiefAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports